/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum BankCardExternalPaymentStatusApiModel {
  Inprocess = 'inprocess',

  Success = 'success',

  Fail = 'fail',

  Canceled = 'canceled',

  Error = 'error',

  Authorized = 'authorized'
}
